import React, { useState } from "react";
import Common_Back_Btn from "../../../../../../../common/common_components/common_back_btn/Common_Back_Btn";
import Common_Report_Offcanvas from "../../../../common_report_offcanvas/Common_Report_Offcanvas";
import ILC_Table from "./ilc_table/ILC_Table";
import ILC_Filter from "./ilc_filter/ILC_Filter";



const ILC = () => {
  const [show, setShow] = useState(false);

  return (
    <section className="Sample_Report">
    

      <div className="Sample_Report_Filter_div">
        <ILC_Filter setShow={setShow} />
      </div>

      <div className="report_table_div">
        <ILC_Table />
      </div>

      <Common_Report_Offcanvas
        title={"Measurement Uncertainty Report"}
        show={show}
        setShow={setShow}
        handleClose={() => {
          setShow(false);
        }}
      />
    </section>
  );
};

export default ILC;
